module.exports = __webpack_public_path__ + "static/media/side-strawberries.f71cf20d.png";